const r = (t) => {
  try {
    return t();
  } catch {
    return;
  }
};
export {
  r as safeGetPos
};
